import { TypedSupabaseClient } from "../../utils/types";

export function getValet(client: TypedSupabaseClient, valetId: string) {
  return client
    .from("users")
    .select(
      `email,full_name,id,oid,roles,scheduler_ext_id,status,updated_at,username,venue_id, venue:venues(name, id)`
    )
    .eq("id", valetId)
    .single();
}
